import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { Spacing } from "@snapchat/snap-design-system";

export const popoverClassName = css`
    .sds-card.sds-container .sds-card-header {
        margin-bottom: ${Spacing.SM}px;
    }
`;

export const dropdownTruncate = css`
    overflow: hidden;
    min-width: 0;

    /* Override PopoverContent and TextContainer min-widths so triggers can shrink at narrow viewports */
    div {
        min-width: 0;
    }
`;

export const AllLensesLinkWrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    width: 100%;
    padding: ${Spacing.SM}px ${Spacing.SM}px 0 ${Spacing.SM}px;
`;
